import { useMemo } from 'react'
import settings from 'settings'
import { FeatureFlagOverrides } from 'app/types'
import { useCartoVersion } from 'features/common/hooks/useCartoVersion'

import fallbackCloudFeatureFlags from 'feature-flag-fallbacks/cloud.json'
import fallbackSelfHostedFeatureFlags from 'feature-flag-fallbacks/self-hosted.json'

export function useFallbackFeatureFlags(): FeatureFlagOverrides {
  const { isSaaS } = useCartoVersion()

  const result = useMemo(() => {
    if (isSaaS) {
      return fallbackCloudFeatureFlags
    } else {
      const customFeatureFlags = settings.featureFlags.reduce((acc, flag) => {
        acc[flag.name] = flag.value
        return acc
      }, {})
      const defaultFeatureFlags = fallbackSelfHostedFeatureFlags
      return { ...defaultFeatureFlags, ...customFeatureFlags }
    }
  }, [isSaaS])
  return result
}
